import { Controller } from "@hotwired/stimulus"

// Keeps the preset rates and the custom one from contradicting each other.
//
// They are the same radio group, so picking a preset already deselects
// "a rate of my own" — but the number typed into the custom field would
// still be submitted, and the server would honour it over the preset. So
// choosing a preset clears the field, and typing in the field selects its
// radio.
export default class extends Controller {
  static targets = ["customRadio", "customField"]

  choosePreset() {
    if (this.hasCustomFieldTarget) this.customFieldTarget.value = ""
  }

  chooseCustom() {
    if (this.hasCustomRadioTarget) this.customRadioTarget.checked = true
  }
}
